export default "__VITE_ASSET__71bece3c__"